module.exports = __webpack_public_path__ + "static/media/Roberto-Stenner_1654200183384.607017f5.png";